import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-pantomime',
    templateUrl: './pantomime.component.html',
    styleUrls: ['./pantomime.component.scss']
})
export class PantomimeComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']})
            .add({name: 'Missziók', instructions: ['/missziok']})
            .add({name: 'Pantomim'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/pantomime/pantomime.component.ts